import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalPropertiesPanelProgress = () => {
  return /*#__PURE__*/_jsx(UIAbstractProgress, {
    incrementFactor: 0.1,
    maximum: 95,
    render: ({
      value,
      done
    }) => /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/_jsx(UINanoProgress, {
        value: value,
        animateOnComplete: done
      })
    })
  });
};
export default ConditionalPropertiesPanelProgress;